export function fixNegativeZero(value: number) {
  // -0 === 0: true
  return value === 0 ? 0 : value
}
